import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  FaBoxes,
  FaLayerGroup,
  FaList,
  FaSearch,
  FaSyncAlt,
  FaPlus,
  FaEdit,
  FaTrash,
  FaTimes,
  FaSave,
  FaBoxOpen
} from 'react-icons/fa';
import './admin/Admin.css';

const DinhMucDinhLuong = () => {
  const [nguyenLieu, setNguyenLieu] = useState([]);
  const [groupedNguyenLieu, setGroupedNguyenLieu] = useState({});
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState('all'); // Changed default to 'all'
  const [formData, setFormData] = useState({
    MaSP: '',
    Ten_SP: '',
    DVT_SP: '',
    DonGia: '',
    TenUser: 'admin'
  });

  // Group materials by MaNLSP (now all will be 'NLBM')
  const groupMaterialsByNLSP = (materials) => {
    const grouped = materials.reduce((acc, item) => {
      const groupKey = item.MaNLSP || 'NLBM';
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    }, {});

    setGroupedNguyenLieu(grouped);
  };

  // Get materials to display based on selected group
  const getDisplayMaterials = () => {
    let materials = [];

    if (selectedGroup === 'none') {
      return [];
    }
    if (selectedGroup === 'all') {
      materials = nguyenLieu;
    } else {
      materials = groupedNguyenLieu[selectedGroup] || [];
    }

    // Filter by search keyword locally
    if (searchKeyword.trim()) {
      const keyword = searchKeyword.toLowerCase();
      materials = materials.filter(item =>
        item.MaSP?.toLowerCase().includes(keyword) ||
        item.Ten_SP?.toLowerCase().includes(keyword) ||
        item.DVT_SP?.toLowerCase().includes(keyword) ||
        item.MaNLSP?.toLowerCase().includes(keyword)
      );
    }

    return materials;
  };

  // Get group statistics
  const getGroupStats = () => {
    const groups = Object.keys(groupedNguyenLieu);
    const totalMaterials = nguyenLieu.length;
    const totalGroups = groups.length;

    return { totalMaterials, totalGroups, groups };
  };

  // Fetch all materials
  const fetchNguyenLieu = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://doticom.vn:3000/api/nguyen-lieu');
      if (response.ok) {
        const data = await response.json();
        setNguyenLieu(data);
        groupMaterialsByNLSP(data);
      } else {
        console.error('Failed to fetch materials');
        toast.error('Không thể tải danh sách nguyên liệu', {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error('Error fetching materials:', error);
      toast.error('Có lỗi xảy ra khi tải dữ liệu nguyên liệu', {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch categories for MaNLSP
  const fetchCategories = async () => {
    try {
      const response = await fetch('https://doticom.vn:3000/categories');
      if (response.ok) {
        const data = await response.json();
        setCategories(data);
      } else {
        console.error('Failed to fetch categories');
        toast.warn('Không thể tải danh sách nhóm nguyên liệu', {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error('Có lỗi xảy ra khi tải nhóm nguyên liệu', {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  // Add new material
  const addNguyenLieu = async (data) => {
    try {
      const response = await fetch('https://doticom.vn:3000/api/nguyen-lieu', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        fetchNguyenLieu();
        closeModal();
        toast.success('Đã thêm nguyên liệu thành công', {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        const errorData = await response.json().catch(() => ({ message: 'Lỗi không xác định' }));
        toast.error(`Không thể thêm nguyên liệu: ${errorData.message || 'Lỗi không xác định'}`, {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error('Error adding material:', error);
      toast.error('Có lỗi xảy ra khi thêm nguyên liệu', {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  // Update material
  const updateNguyenLieu = async (maSP, data) => {
    try {
      const response = await fetch(`https://doticom.vn:3000/api/nguyen-lieu/${maSP}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        fetchNguyenLieu();
        closeModal();
        toast.success('Đã cập nhật nguyên liệu thành công', {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        const errorData = await response.json().catch(() => ({ message: 'Lỗi không xác định' }));
        toast.error(`Không thể cập nhật nguyên liệu: ${errorData.message || 'Lỗi không xác định'}`, {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } catch (error) {
      console.error('Error updating material:', error);
      toast.error('Có lỗi xảy ra khi cập nhật nguyên liệu', {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  // Delete material
  const deleteNguyenLieu = async (maSP) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa nguyên liệu này?')) {
      try {
        const response = await fetch(`https://doticom.vn:3000/api/nguyen-lieu/${maSP}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          fetchNguyenLieu();
          toast.success('Đã xóa nguyên liệu thành công', {
            position: "top-right",
            autoClose: 3000,
          });
        } else {
          const errorData = await response.json().catch(() => ({ message: 'Lỗi không xác định' }));
          toast.error(`Không thể xóa nguyên liệu: ${errorData.message || 'Lỗi không xác định'}`, {
            position: "top-right",
            autoClose: 5000,
          });
        }
      } catch (error) {
        console.error('Error deleting material:', error);
        toast.error('Có lỗi xảy ra khi xóa nguyên liệu', {
          position: "top-right",
          autoClose: 5000,
        });
      }
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (editingItem) {
      const { MaSP, ...updateData } = formData;
      updateNguyenLieu(editingItem.MaSP, updateData);
    } else {
      addNguyenLieu(formData);
    }
  };

  // Open modal for add/edit
  const openModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setFormData({
        MaSP: item.MaSP,
        Ten_SP: item.Ten_SP,
        DVT_SP: item.DVT_SP,
        DonGia: item.DonGia,
        TenUser: item.TenUser || 'admin'
      });
    } else {
      setEditingItem(null);
      setFormData({
        MaSP: '',
        Ten_SP: '',
        DVT_SP: '',
        DonGia: '',
        TenUser: 'admin'
      });
    }
    setShowModal(true);

    // Fetch categories when opening modal
    if (categories.length === 0) {
      fetchCategories();
    }
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setFormData({
      MaSP: '',
      Ten_SP: '',
      DVT_SP: '',
      DonGia: '',
      TenUser: 'admin'
    });
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle search
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
    // No need for API call or debounce - filtering happens in getDisplayMaterials
  };

  // Handle group selection
  const handleGroupChange = (e) => {
    setSelectedGroup(e.target.value);
  };

  useEffect(() => {
    fetchNguyenLieu();
    fetchCategories();
  }, []);

  const displayMaterials = getDisplayMaterials();
  const { totalMaterials, totalGroups, groups } = getGroupStats();

  return (
    <>
      {/* Header */}
      <div className="admin-header">
        <div className="header-left">
          <h1>Quản lý nguyên liệu  cho Định mức Định lượng</h1>
          <p>Quản lý nguyên liệu và dvt sản phẩm</p>
        </div>
      </div>

      {/* Stats Section */}
      <div className="content-section">
        <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', marginBottom: '24px' }}>
          <div className="stat-card">
            <div className="stat-header">
              <div className="stat-icon">
                <FaBoxes />
              </div>
            </div>
            <div className="stat-content">
              <div className="stat-value">{totalMaterials}</div>
              <div className="stat-label">Tổng nguyên liệu</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-header">
              <div className="stat-icon">
                <FaLayerGroup />
              </div>
            </div>
            <div className="stat-content">
              <div className="stat-value">{totalGroups}</div>
              <div className="stat-label">Nhóm nguyên liệu</div>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-header">
              <div className="stat-icon">
                <FaList />
              </div>
            </div>
            <div className="stat-content">
              <div className="stat-value">{displayMaterials.length}</div>
              <div className="stat-label">Đang hiển thị</div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="content-section">
        <div className="card">
          <div className="card-header">
            <div className="shift-actions">
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                <input
                  type="text"
                  placeholder="Tìm kiếm nguyên liệu..."
                  value={searchKeyword}
                  onChange={handleSearch}
                  className="form-control"
                  style={{ width: '250px', minWidth: '200px' }}
                />

                <select
                  value={selectedGroup}
                  onChange={handleGroupChange}
                  className="form-select"
                  style={{ width: '200px', minWidth: '150px' }}
                >
                  <option value="all">Tất cả nguyên liệu ({totalMaterials})</option>
                  {groups.map(group => (
                    <option key={group} value={group}>
                      {group} ({groupedNguyenLieu[group]?.length || 0})
                    </option>
                  ))}
                </select>

                <button
                  className="btn btn-primary"
                  onClick={() => fetchNguyenLieu()}
                  disabled={loading}
                >
                  <FaSyncAlt style={{ marginRight: '4px' }} />
                  Làm mới
                </button>
              </div>
              <button
                className="btn btn-primary"
                onClick={() => openModal()}
              >
                <FaPlus style={{ marginRight: '4px' }} />
                Thêm nguyên liệu
              </button>
            </div>
          </div>

          <div className="card-body">
            {selectedGroup !== 'all' && selectedGroup !== 'none' && (
              <div style={{
                background: '#f8f9fa',
                padding: '12px 16px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #e9ecef'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FaLayerGroup className="text-primary" />
                  <strong>Nhóm đang xem:</strong>
                  <span className="badge" style={{
                    background: '#1976d2',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px'
                  }}>
                    {selectedGroup}
                  </span>
                  <span className="text-muted">({displayMaterials.length} nguyên liệu)</span>
                </div>
              </div>
            )}

            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2 text-muted">Đang tải dữ liệu...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped shift-table">
                  <thead>
                    <tr>
                      <th>Mã SP</th>
                      <th>Tên sản phẩm</th>
                      <th>Đơn vị tính</th>
                      <th>Đơn giá</th>
                      <th>Mã NLSP</th>
                      <th>Ngày cập nhật</th>
                      <th>Người tạo</th>
                      <th>Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayMaterials.length === 0 ? (
                      <tr>
                        <td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                          <FaBoxOpen style={{ fontSize: '48px', color: '#ddd', marginBottom: '16px' }} />
                          <p className="text-muted">
                            {searchKeyword
                              ? 'Không tìm thấy nguyên liệu nào'
                              : selectedGroup === 'all'
                                ? 'Chưa có nguyên liệu nào'
                                : `Nhóm "${selectedGroup}" chưa có nguyên liệu nào`
                            }
                          </p>
                        </td>
                      </tr>
                    ) : (
                      displayMaterials.map((item) => (
                        <tr key={item.MaIDSP}>
                          <td>{item.MaSP}</td>
                          <td>{item.Ten_SP}</td>
                          <td>{item.DVT_SP}</td>
                          <td>{item.DonGia ? Number(item.DonGia).toLocaleString('vi-VN') + ' đ' : '-'}</td>
                          <td>
                            <span className="badge bg-primary" style={{
                              background: '#1976d2',
                              color: 'white',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              fontSize: '11px'
                            }}>
                              {item.MaNLSP || 'NLBM'}
                            </span>
                          </td>
                          <td>{item.NgayUp ? new Date(item.NgayUp).toLocaleDateString('vi-VN') : '-'}</td>
                          <td>{item.TenUser || '-'}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-primary me-1"
                              onClick={() => openModal(item)}
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => deleteNguyenLieu(item.MaSP)}
                            >
                              <FaTrash />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal for Add/Edit */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editingItem ? 'Cập nhật nguyên liệu' : 'Thêm nguyên liệu mới'}</h3>
              <button className="modal-close" onClick={closeModal}>
                <FaTimes />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="MaSP">Mã sản phẩm *</label>
                  <input
                    type="text"
                    id="MaSP"
                    name="MaSP"
                    value={formData.MaSP}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                    disabled={editingItem}
                    placeholder="Nhập mã sản phẩm"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="Ten_SP">Tên sản phẩm *</label>
                  <input
                    type="text"
                    id="Ten_SP"
                    name="Ten_SP"
                    value={formData.Ten_SP}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                    placeholder="Nhập tên sản phẩm"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="DVT_SP">Đơn vị tính *</label>
                  <select
                    id="DVT_SP"
                    name="DVT_SP"
                    value={formData.DVT_SP}
                    onChange={handleInputChange}
                    className="form-select"
                    required
                  >
                    <option value="">Chọn đơn vị tính</option>
                    <option value="g">Gam (g)</option>
                    <option value="kg">Kilogram (kg)</option>
                    <option value="vien">Viên</option>
                    <option value="lang">Lạng (hg)</option>
                    <option value="ml">Mililít (ml)</option>
                    <option value="lit">Lít (l)</option>
                    <option value="can">Can</option>
                    <option value="binh">Bình</option>
                    <option value="chai">Chai</option>
                    <option value="hop">Hộp</option>
                    <option value="cai">Cái</option>
                    <option value="chiec">Chiếc </option>
                    <option value="cay">Cây </option>
                    <option value="goi">Gói</option>
                    <option value="thung">Thùng</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="DonGia">Đơn giá</label>
                  <input
                    type="number"
                    id="DonGia"
                    name="DonGia"
                    value={formData.DonGia}
                    onChange={handleInputChange}
                    className="form-control"
                    min="0"
                    step="0.01"
                    placeholder="Nhập đơn giá"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="TenUser">Người tạo</label>
                  <input
                    type="text"
                    id="TenUser"
                    name="TenUser"
                    value={formData.TenUser}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Tên người tạo"
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Hủy
                </button>
                <button type="submit" className="btn btn-primary">
                  <FaSave style={{ marginRight: '4px' }} />
                  {editingItem ? 'Cập nhật' : 'Thêm mới'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default DinhMucDinhLuong;

